import * as refills from './list'

export const allRefills = Object.values(refills).sort((previous, current) =>
    current.date_time.localeCompare(previous.date_time),
)
